import { useEffect } from 'react'
import { useExperienceStore } from '../store/experienceStore'
import { MAX_TIME_SPEED } from '../config/eras'

export function useKeyboardMouse() {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement)
        return
      const store = useExperienceStore.getState()
      if (e.code === 'Space') {
        e.preventDefault()
        store.togglePauseByUser()
        store.setInputMode('keyboard')
        return
      }
      if (e.code === 'ArrowLeft' || e.key === 'a' || e.key === 'A') {
        store.setTimeSpeed(-MAX_TIME_SPEED * 0.7)
        store.setInputMode('keyboard')
      }
      if (e.code === 'ArrowRight' || e.key === 'd' || e.key === 'D') {
        store.setTimeSpeed(MAX_TIME_SPEED * 0.7)
        store.setInputMode('keyboard')
      }
      if (e.code === 'ArrowUp' || e.key === 'w' || e.key === 'W') {
        store.setTimeSpeed(0)
      }
      if (e.key === '?' || (e.shiftKey && e.key === '/')) {
        store.setOnboardingStep(0)
      }
    }

    const onKeyUp = (e: KeyboardEvent) => {
      if (
        e.code === 'ArrowLeft' ||
        e.code === 'ArrowRight' ||
        e.key === 'a' ||
        e.key === 'A' ||
        e.key === 'd' ||
        e.key === 'D'
      ) {
        const store = useExperienceStore.getState()
        if (store.inputMode === 'keyboard' && !store.pausedByUser) {
          store.setTimeSpeed(0)
        }
      }
    }

    const onWheel = (e: WheelEvent) => {
      // only when not scrolling a panel
      if ((e.target as HTMLElement)?.closest?.('[data-ui-scroll]')) return
      e.preventDefault()
      const store = useExperienceStore.getState()
      const delta = -Math.sign(e.deltaY) * 0.08
      const next = Math.max(
        -MAX_TIME_SPEED,
        Math.min(MAX_TIME_SPEED, store.timeSpeed + delta),
      )
      store.setTimeSpeed(next)
      store.setInputMode('mouse')
    }

    window.addEventListener('keydown', onKeyDown)
    window.addEventListener('keyup', onKeyUp)
    window.addEventListener('wheel', onWheel, { passive: false })
    return () => {
      window.removeEventListener('keydown', onKeyDown)
      window.removeEventListener('keyup', onKeyUp)
      window.removeEventListener('wheel', onWheel)
    }
  }, [])
}
